<script setup lang="ts">
  import { IconSuccess, Text } from '@ui-kit';
</script>

<template>
  <span class="scan-screen-success" data-testid="scan-screen-success">
    <IconSuccess style="width: 32px; height: 32px;" />
  </span>
  <Text font="body-regular-12" color="success">
    {{ $t('Нашли товар, загружаем данные') }}
  </Text>
</template>

<style scoped>
  .scan-screen-success {
    display: flex;
    border-radius: 100%;
    border: 2px solid var(--sf-base-icon-success);
    padding: 4px;
  }

  .scan-screen-success svg {
    stroke: var(--sf-base-icon-success);
  }
</style>
